import { ActionButtonProps, Box, BoxProps, CheckBox, ColorOptions, Form } from '@jfs/ui-new'
import { GradientButton } from '../../components/GradientButton'
import { isEmpty } from '@jfs/utils'
import { useFocusEffect, useNavigation } from '@react-navigation/core'
import { useCallback, useEffect } from 'react'
import { FlatList } from 'react-native'
import { useLazyApiData, useStores } from '../../data/store'
import { convertSnakeCaseToCaps, convertToCaps, modifiedUserName } from '../../utils'
import { UserForm } from './UserForm'

const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}

const AddUpdateUser = (props: any) => {
  const nav = useNavigation()
  const id = props?.route?.params?.id
  const { getDetails, updateUser, groupIdNames, fetchUserDetails, username, updateAccessConfig } = useStores(
    (store) => ({
      getDetails: store.userManagement.getUserDetails,
      updateUser: store.userManagement.updateUser,
      groupIdNames: store.userManagement.getGroupIdNames(),
      fetchUserDetails: store.userManagement.fetchUserDetails,
      username: store.user.name,
      updateAccessConfig: store.user.updateAccessConfig,
    }),
  )

  const [userDetailsApi] = useLazyApiData(fetchUserDetails)
  useFocusEffect(
    useCallback(() => {
      userDetailsApi(id)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]),
  )
  const [lazyUpdateUserApi, { state }] = useLazyApiData(updateUser)

  useEffect(() => {
    if (state === 'fulfilled') {
      if (props?.onUpdate) {
        props?.onUpdate()
      }
      if (modifiedUserName(username) === data.name) {
        updateAccessConfig('')
        nav.reset({
          index: 0,
          routes: [{ name: 'dashboard', params: { isForceRefresh: true } }],
        })
      } else {
        nav.navigate('users')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])
  const renderItem = ({ item, index }: any) => {
    return (
      <Box flexDirection={'row'} borderTopWidth={index === 0 ? 0 : 1} borderTopColor={'DISABLED_GREY'}>
        <Box
          bg={'BACKGROUND'}
          p={16}
          borderTopLeftRadius={8}
          borderBottomLeftRadius={8}
          f={0.15}
          borderRightWidth={1}
          borderRightColor={'DISABLED_GREY'}>
          <CheckBox
            checked={item?.titleAccessible}
            textLabel={convertSnakeCaseToCaps(item?.title)}
            iconSize={16}
            fontSize={12}
            textColor={'PRIMARY_GREY'}
            disabled
            color={'DISABLED_GREY'}
          />
        </Box>
        <Box flexDirection={'column'} ph={16} f={0.85} pv={8}>
          {item.subTitleData.map((item: any) => {
            const objKeys = Object.keys(item)?.filter((key) => key !== 'titleAccessible' && key !== 'title')
            return (
              <Box flexDirection={'column'} pv={8} align="flex-start">
                <CheckBox
                  checked={item?.titleAccessible}
                  textLabel={convertSnakeCaseToCaps(item?.title)}
                  iconSize={16}
                  fontSize={12}
                  disabled
                  textColor={'PRIMARY_GREY'}
                  color={'DISABLED_GREY'}
                />
                <Box
                  paddingHorizontal={24}
                  marginTop={16}
                  flexDirection={'row'}
                  justifyContent={'space-between'}
                  w={'100%'}>
                  {objKeys?.map((obj: any) => {
                    return (
                      <CheckBox
                        checked={item[obj]}
                        textLabel={convertToCaps(obj)}
                        disabled
                        iconSize={16}
                        fontSize={12}
                        textColor={'PRIMARY_GREY'}
                        color={'DISABLED_GREY'}
                      />
                    )
                  })}
                </Box>
              </Box>
            )
          })}
        </Box>
      </Box>
    )
  }

  const SHOW_CHECKBOX = false
  const data = getDetails(id)
  const actionButtons = ({ values, isCurrentFormValid }: ActionButtonProps) => {
    const handleOnPress = () => {
      lazyUpdateUserApi({ id, data, ...values })
    }
    return (
      <>
        {SHOW_CHECKBOX && !isEmpty(id) && (
          <Box bg={'WHITE'} borderColor={'DISABLED_GREY'} borderWidth={1}>
            <FlatList data={data?.accessConfig} renderItem={renderItem} extraData={data?.accessConfig} />
          </Box>
        )}
        <Box align="center" p={16}>
          <GradientButton
            title={id ? 'Update' : 'Proceed'}
            disabled={!isCurrentFormValid}
            onPress={handleOnPress}
            height={40}
          />
        </Box>
      </>
    )
  }
  const getData = () => {
    return {
      id: data?.id,
      username: data?.name,
      type: data?.type,
      name: data?.groupName,
      status: data?.status ?? 'Active',
    }
  }
  return (
    <Box {...styles.container} p={16}>
      <Form
        formData={UserForm(groupIdNames, id)}
        actionButtons={actionButtons}
        initialValues={getData()}
        container={FormBox}
      />
    </Box>
  )
}

export default AddUpdateUser
const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  header: {
    ...shadow,
    marginTop: 16,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
}
